import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useOpenableControls } from '../../../generic-hooks'
import { ExperimentOdsVideoConsultationWrapper } from '../../ods/components/ExperimentOdsVideoConsultationWrapper'
import { ProductPageOdsProvider } from '../../ods/components/productPageODSContext'

import { ProductPageOdsDialog } from './ProductPageOdsDialog'

export const ProductPageOdsDialogCtaButton: FC = () => {
  const openableControls = useOpenableControls()

  return (
    <ProductPageOdsProvider>
      <Button
        className="mb-2.5 w-full"
        color="secondary"
        data-qa-id="form-buybox-large_online-doctor-service"
        onClick={openableControls.handleOpen}
      >
        <ExperimentOdsVideoConsultationWrapper
          childVideoConsultationV1={
            <FormattedMessage id="buyBox.link.label.onlineDoctorService" />
          }
          childZavaProvider={
            <FormattedMessage id="buyBox.link.label.onlineDoctorService.zava" />
          }
        />
      </Button>
      <ProductPageOdsDialog
        onClose={openableControls.handleClose}
        open={openableControls.isOpen}
      />
    </ProductPageOdsProvider>
  )
}
